<div class="flex flex-col divide-y">
  @for (fund of fundsArray; track fund) {
    <mat-expansion-panel class="shadow-none hover:shadow-none" [togglePosition]="'before'">
      <mat-expansion-panel-header class="px-1 h-18 sm:h-[55px] hover:bg-white border-b-black">
        <mat-panel-title>
          <div>
            <span class="pr-2 text-base font-normal"> {{ fund.funding.title }} </span>
            <br class="md:hidden" />
            @if (!fund.funding.isBox) {
              <span class="text-sm font-normal text-secondary md:hidden">
                {{ fund.funding?.mnemonic }}
              </span>
            }
          </div>
          <!-- Self aware panel -->
        </mat-panel-title>
        <mat-panel-description class="flex flex-row justify-end flex-grow-[0.25]">
          <div class="flex items-center justify-end w-full gap-2 text-base font-normal">
            <span class="text-default"> {{ fund.percentage | number: '1.0-1' : 'es-CL' }}% </span>
            <span class="flex md:hidden">
              <span
                class="flex items-end w-1 overflow-hidden rounded h-9"
                [style.backgroundColor]="getLightColor(fund?.color!)"
              >
                <span
                  class="flex w-full"
                  [style.height]="fund.percentage + '%'"
                  [style.backgroundColor]="fund?.color"
                ></span>
              </span>
            </span>
            <div class="hidden w-20 bg-gray-100 md:w-28 md:flex">
              <span
                class="flex h-4 col-span-3 rounded-s-sm"
                [style.backgroundColor]="fund.color"
                [style.width]="fund.percentage + '%'"
              ></span>
            </div>
          </div>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="flex flex-col gap-2">
        @for (compositionItem of fund.funding?.fundingCompositions; track compositionItem) {
          <div class="flex flex-row items-center justify-between gap-1 text-secondary">
            <span>
              {{ compositionItem?.subcategory?.name }}
            </span>
            <span> {{ compositionItem.percentage | number: '1.0-1' : 'es-CL' }}% </span>
          </div>
        }
        <mat-divider></mat-divider>
        <div>
          @if (!fund.funding.isBox) {
            <span class="font-medium">
              {{ fund.funding?.mname }} ({{ fund?.funding?.mnemonic }})
              @if (
                fund.funding?.informativeBrochureId?.value ||
                fund.funding?.informativeBrochureUrl !== ''
              ) {
                <a
                  class="relative bottom-[-1px]"
                  [href]="
                    fund.funding?.informativeBrochureUrl !== ''
                      ? fund.funding?.informativeBrochureUrl
                      : urlFileBase +
                        fund.funding?.informativeBrochureId?.value +
                        '/?token=' +
                        token
                  "
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <mat-icon
                    class="mt-1 icon-size-4 text-primary"
                    [svgIcon]="'heroicons_outline:document-plus'"
                    (click)="tooltipCaja.toggle()"
                    #tooltipCaja="matTooltip"
                    matTooltip="Ver folleto"
                  ></mat-icon>
                </a>
              }
            </span>
          }
          <p class="pt-2">
            {{ fund.funding?.description }}
          </p>
        </div>
        @for (feature of fund?.funding?.featuresjson; track feature) {
          <div class="flex gap-2">
            <i class="mt-1 fas fa-check text-primary"></i>
            <span class="px-0 col-10">
              <span class="underline">{{ getFeaturesSplit(feature, 0) }}</span>
              :
              <span>{{ getFeaturesSplit(feature, 1) }}</span>
            </span>
          </div>
        }
      </div>
    </mat-expansion-panel>
  }
</div>
